module.exports = __webpack_public_path__ + "img/B102.ca39e223.png";